const videoplayerMixin = {
    props: ['playerForwardBackward'],
    mounted() {
        this.$nextTick(() =>{
            this.player.on('loadedmetadata',() =>{
                this.$root.$emit('player-duration',this.player.duration());
                this.$root.$emit('player-obj',this.player);
            });
        });
    },

    watch:{
        immediate:true,
        playerForwardBackward:function(newVal){
            console.log('newval',newVal);
            this.player.currentTime(newVal);
        },
    }

};

export default videoplayerMixin;